<textarea [readonly]="true" [value]=""></textarea>

